import { isNumber, isBoolean } from 'util';

const listHelper = {


	countLength(list) {
		return list.length;

	},

	// FP: markerar de items som är inom ett visst span
	selectList(selectedIndex, index, list) {

		var min = Math.min(selectedIndex, index);
		var max = Math.max(selectedIndex, index);
		var i = 0;
		var resultList = [];
		list.forEach(entity => {
			if (i >= min && i <= max) {
				resultList.push(entity);
			}
			i++
		});

		return resultList;
	},


	// filterar en lista utifrån dess .search och en sträng med ord
	filterList(list, filter) {

		var words = filter.split(" ");

		var filteredList = [];

		list.forEach(function (item) {

			var add = true;


			words.forEach(function (word) {


				if (!add) { // FP: Om den tidigare blivit false så kör inte resten av orden.
					return;
				}

				// om det är en produkt och vi söker på ett tal, (rensar bort före sökningen på text)
				if (item.productId && Number.isInteger(item.productId)) {

					if (word.startsWith("-")) { // lägre än
						const productId = parseInt(word.replace("-", ""));
						if (item.productId <= productId) {
							return;
						}
					}

					if (word.endsWith("-")) { // större än
						const productId = parseInt(word.replace("-", ""));
						if (item.productId >= productId) {
							return;
						}
					}
				}

				// om vi har ett id och vi söker på ett tal (funkar på entity tex), kanske flytta detta till en egen funktion där man kan 
				// skicka med id-fält som en parameter. 
				// raderade, ändrar sortering och desc istället. 
				/*if (item.id && Number.isInteger(item.id)) {

					const id = parseInt(word.replace("ID:", ""));

					console.log('FP: item.id:' + item.id + ", id: " + id);


					if (item.id == id) {
						add = true;
						return;
					}
				}*/

				if (!item.search) {
					console.log('FP: item.search is null');
					item.search = ""

				}

				let search = item.search.toLowerCase() // FP: Varje rad i listan måste ha en search-property

				if (item.meta != null) {
					search = search + " " + listHelper.getSearchFromMeta(item.meta)
				}

				search = search.toLowerCase()

				//console.log("FP: " + search);

				if (add && !search.includes(word.toLowerCase())) {
					add = false;
					return;
				}

			})

			if (add) {
				filteredList.push(item);
			}

		});

		return filteredList
	},

	getTodayDate() {
		return new Date().toISOString().substring(0, 10);
	},

	getSearchFromMeta(meta) {
		var search = "";

		if (meta.view != null) {

			if (meta.view.toDateString() == new Date().toDateString()) {
				search += " VIEW:VIEW_TODAY"
			} else {
				search += " VIEW:VIEW_OLD"
			}



		}

		if (meta.selected === true) {
			search += " SELECTED:SELECTED";
		}


		if (meta.modified != null && meta.modified.toDateString() == new Date().toDateString()) {
			search += " TODAY:TODAY";
		}
		return search;

	},
	sortList(list, property, desc) {

		console.log('FP: sort: property: ', property);
		console.log('FP: sort: desc: ', desc);

		return list.filter((item) => item !== null).sort((itemA, itemB) => {
			//return sortEntity(a[property], b[property], desc);

			var a = itemA[property]
			var b = itemB[property]

			if (property.includes(".")) { //  om det är en property av en property... 
				//console.log("FP: include:" + property);
				var p = property.split(".")
				//console.log("FP: xx:", p);


				a = itemA[p[0]][p[1]];
				b = itemB[p[0]][p[1]];
			}

			//const b = itemB["reseller"]["name"]

			//console.log("FP: Compare: " + a + " : " + b);

			if (desc) {


				if (a == null) {
					return -1
				}

				if (b == null) {
					return 1
				}

				if (isNumber(a)) {
					if (a > b) {
						return -1;
					} else if (a < b) {
						return 1;
					} else {
						return 0;
					}
				}

				if (isBoolean(a)) {
					if (a === b) {
						return 0;
					} else {
						return 1;
					}
				}

				//console.log('FP: sort: string: asc: a: ', a);
				//console.log('FP: sort: string: asc: b: ', b);

				a = String(a);
				b = String(b);

				if (a.toLowerCase() > b.toLowerCase()) {
					return -1;
				} else if ((a.toLowerCase() < b.toLowerCase())) {
					return 1;
				} else {
					return 0;
				}


			} else {

				if (a == null) {
					return 1
				}

				if (b == null) {
					return -1
				}

				if (isNumber(a)) {
					console.log('FP: sort: isNumber');
					if (a < b) {
						return -1;
					} else if (a > b) {
						return 1;
					} else {
						return 0;
					}
				}

				if (isBoolean(a)) {
					console.log('FP: sort: isBoolean');
					if (a === b) {
						return 0;
					} else {
						return -1;
					}
				}
				//console.log('FP: sort: string: desc: a: ', a);
				//console.log('FP: sort: string: desc: b: ', b);

				a = String(a);
				b = String(b);

				if (a.toLowerCase() < b.toLowerCase()) {
					return -1;
				} else if ((a.toLowerCase() > b.toLowerCase())) {
					return 1;
				} else {
					return 0;
				}


			}
		})

	},

	// FP: sorterar en lista utifrån en propery och desc om det är i stigande eller fallande ordning. 
	// Kollar också att item inte är null 
	// man kan använda . i property user.name tex 
	sortList_OLDER(list, property, desc) {

		return list.filter((item) => item !== null).sort((itemA, itemB) => {
			//return sortEntity(a[property], b[property], desc);

			var a = itemA[property]
			var b = itemB[property]

			if (property.includes(".")) { //  om det är en property av en property... 
				// console.log("FP: inclide:" + property);
				var p = property.split(".")
				//console.log("FP: xx:", p);


				a = itemA[p[0]][p[1]];
				b = itemB[p[0]][p[1]];
			}

			//const b = itemB["reseller"]["name"]

			//console.log("FP: Compare: " + a + " : " + b);

			if (desc) {
				if (a == null) {
					return 1
				}

				if (b == null) {
					return -1
				}

				if (isNumber(a)) {
					return a < b
				}

				if (isBoolean(a)) {
					return a < b
				}

				return a.toLowerCase() < b.toLowerCase()

			} else {

				if (a == null) {
					return -1
				}

				if (b == null) {
					return 1
				}

				if (isNumber(a)) {
					return a > b
				}

				if (isBoolean(a)) {
					return a > b
				}

				return a.toLowerCase() > b.toLowerCase()
			}
		})

	},
	// Skapar en ny lista av de "limit" första objekt
	trimToLimit(list, limit) {

		var newList = [];

		var i = 0;

		list.forEach((item) => {
			if (i++ < limit) {
				newList.push(item);
			}
		});

		return newList;

	},
	pathList(path) {

		var s = "";
		var list = [];

		path.split("/").forEach(folder => {

			if (s.length > 0) {
				s = s + " / "
			}

			s = s + folder
			list.push(s);
		})

		return list;



	},
	/*
	yearList(list) {
		// för att räkna på andra hållet:
		// a < b, year + 1
		list.sort((a, b) => a > b);

		var result = ""

		var currentYear = 0;

		var close = "";
		var separator = "";



		list.forEach(year => {

			year = parseInt(year);

			if (currentYear == year) {
				return
			}

			if (currentYear == year - 1) {
				//result = result + " [" + year + "], "  
				close = "-" + year
			} else {

				if (close != "") {
					result += close
					close = ""
				}

				result += separator + year
			}

			separator = ", "

			currentYear = year


		})

		result = result + close

		return result
	},
	// skapar en lista av åren mellan två givna år. 
	yearDescList(yearA, yearB) {

		if (!yearA) {
			return null;
		}

		if (!yearB) {
			return null;
		}

		if (Math.abs(yearA - yearB) != 1 && yearB > 0 && yearA > 0) {
			var from = 0;
			var to = 0;

			yearA = parseInt(yearA);
			yearB = parseInt(yearB);

			if (yearA < yearB) {
				to = yearB - 1;
				from = yearA;
			} else {
				from = yearB + 1;
				to = yearA;
			}


			var yearDescList = "";

			for (; from <= to; from++) {
				yearDescList += from;

				if (from < to) {
					yearDescList += ",";
				}
			}

			return yearDescList;
		}

		return null;
	},

	formatYearList(years, separator) {

		years = [...new Set(years)]; // tar bort dubeltter
		years.sort();

		// loopa åren
		if (years.length >= 2) {
			let string = "";
			let buffering = false;

			for (let i = 0; i < years.length; i++) {
				const year = years[i];

				if (i + 1 == years.length) {
					// om det är det sista året så avsluta
					string += year;
				} else {
					let nextYear = years[i + 1];

					if (nextYear - year == 1) {
						if (buffering) {
							continue;
						} else {
							buffering = true;
							string += year + "-";
						}
					} else {
						buffering = false;
						string += year + separator;
					}
				}
			}
			return string;
		} else {
			return years.join(separator);
		}
	},*/
	filter(keywords, search){
		//console.log('FP: keywords: ', keywords);
		//console.log('FP: search: ', search);

		const hit = (keywords?.toLowerCase().includes(search?.toLowerCase()));
		return hit;
		
	},

	filterIgnoreSpace(keywords, search) {
		//console.log('FP: keywords: ', keywords);
		//console.log('FP: search: ', search);

		var hit = (keywords?.toLowerCase().includes(search?.toLowerCase()));
		if (hit){
			return hit;
		}

		hit = (keywords?.toLowerCase().replaceAll(" ", "")?.includes(search?.toLowerCase().replaceAll(" ", "")));

		return hit;

	}



}



export default listHelper